<template>
  <v-container grid-list-md>
    <v-card class="mx-auto" width="500">
      <v-overlay
        absolute
        class="d-flex flex-column text-center"
        opacity="0.35"
        z-index="1"
        :value="peticionDocCliente"
      >
        <div>
          <v-progress-circular width="2" size="50" color="white" indeterminate>
            <v-icon size="30">mdi-timer-sand</v-icon>
          </v-progress-circular>
        </div>
        Cargando Datos...
      </v-overlay>
      <v-alert
        v-if="!peticionDocCliente && datosNew.length === 0"
        icon="mdi-minus-circle"
        dark
        border="right"
        color="error"
      >
        No Hay Registros para Mostrar
      </v-alert>
      <v-card-text
        class="text-left text-body-2 font-weight-bold"
        v-if="step === 2"
      >
        <v-icon large color="accent" @click="handleBack">
          mdi-chevron-left </v-icon
        >{{ currentTitle }}
      </v-card-text>
      <div class="d-flex justify-space-between" v-if="step === 1">
        <span></span>
        <span class="font-weight-bold mr-3">
          {{
            peticionDocCliente
              ? ""
              : `Monto Total: ${format(MontoTotal, 1)} ${
                  simboloMoneda[tipoMoneda]
                }`
          }}
        </span>
      </div>
      <v-window v-model="step">
        <v-window-item :value="1">
          <v-virtual-scroll
            :bench="benched"
            :items="datosNew"
            height="490"
            item-height="90"
          >
            <template v-slot:default="{ item }">
              <v-list-item
                :key="item.NumeroPed"
                dense
                @click="handleDoc(item)"
                three-line
              >
                <v-list-item-content style="cursor: pointer">
                  <v-list-item-title class="text-start">
                    <v-badge
                      color="primary"
                      :content="numDoc(item.Cliente, item.NumeroPed)"
                      class="ml-1"
                    >
                    </v-badge>
                    <span class="mx-6 text-wrap">
                      {{ item.NombreCli }}
                    </span></v-list-item-title
                  >
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span> N° Pedido:</span>
                    <span class="font-weight-bold"> {{ item.NumeroPed }}</span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span> Monto: </span
                    ><span class="font-weight-bold">{{
                      `${format(Saldo(item.Cliente, item.NumeroPed), 1)} ${
                        simboloMoneda[tipoMoneda]
                      } `
                    }}</span>
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider></v-divider>
            </template>
          </v-virtual-scroll>
        </v-window-item>
        <v-window-item :value="2">
          <v-virtual-scroll
            :bench="benched"
            :items="detalleBackOrder(numped)"
            height="490"
            item-height="90"
          >
            <template v-slot:default="{ item }">
              <v-list-item three-line dense :key="item.NumeroPed">
                <v-list-item-avatar tile size="60">
                  <ImgInsideRow :codart="item.Codigo" />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="d-flex justify-space-between">
                    <span>Pedido:</span>
                    <span class="font-weight-bold">
                      {{ `${item.NumeroPed}` }}
                    </span>
                  </v-list-item-title>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Codigo:</span>
                    <span class="font-weight-bold">
                      {{ `${item.Codigo}` }}
                    </span>
                  </v-list-item-subtitle>
                  <v-list-item-subtitle
                  class="text-no-wrap d-flex justify-space-between"
                  >
                 
                  <span class="font-weight-bold">
                    {{ `${item.Nombre}` }}
                  </span>
                   
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Fecha Pedido:</span>
                    <span class="font-weight-bold">
                      {{ `${formatFecha(item.FechaPedido, 1)}` }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Fecha Backorder:</span>
                    <span class="font-weight-bold">
                      {{ `${formatFecha(item.FechaBackorder, 1)}` }}</span
                    >
                  </v-list-item-subtitle>
                  <v-list-item-subtitle class="d-flex justify-space-between">
                    <span>Cant:</span>
                    <span class="font-weight-bold">{{
                      `  ${item.Cantidad}`
                    }}</span>
                    <span>Precio:</span>
                    <span class="font-weight-bold">
                      {{
                        `${format(item.PrecioTot[tipoMoneda], 1)} ${
                          simboloMoneda[tipoMoneda]
                        }`
                      }}</span
                    >
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider />
            </template>
          </v-virtual-scroll>
        </v-window-item>
      </v-window>
    </v-card>
  </v-container>
</template>

<script>
import ImgInsideRow from "@/components/ImgInsideRow";
import { format, formatFecha } from "@/static/funciones";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  components: {
    ImgInsideRow,
  },
  data() {
    return {
      benched: 0,
      step: 1,
      nbcli: "",
      idcliente: 0,
      numped: 0,

      headers: [
        {
          text: "Codigo",
          align: "center",
          value: "Codigo",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Descripción",
          align: "center",
          value: "Nombre",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Pedido",
          align: "center",
          value: "NumeroPed",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Ref",
          align: "center",
          value: "Referencia",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Fecha Pedido",
          align: "center",
          value: "FechaPedido",
          groupable: false,
          sortable: true,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Fecha BackOrder",
          align: "center",
          value: "FechaBackorder",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Cantidad",
          align: "center",
          value: `Cantidad`,
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
        {
          text: "Precio",
          align: "center",
          value: "PrecioTot",
          groupable: false,
          sortable: false,
          divider: true,
          class: "subtitle-2 font-weight-bold",
        },
      ],
    };
  },
  props: {
    codcli: Number,
  },
  created() {
    this.obtenerDatos();
  },
  methods: {
    ...mapActions(["get_DetalleClienteDoc"]),
    ...mapMutations(["CRL_DetalleClienteBkO", "set_OpcCli"]),
    format,
    formatFecha,
    handleBack() {
      this.step--;
    },
    handleDoc(item) {
      this.nbcli = item.NombreCli;
      this.idcliente = item.Cliente;
      this.numped = item.NumeroPed;
      this.step++;
    },
    Saldo(cliente, numped) {
      let num = 0;
      if (Object.entries(this.DetalleClienteBkO).length !== 0) {
        const { wfbackorder } = this.DetalleClienteBkO;
        if (wfbackorder !== undefined) {
          num = wfbackorder
            .filter((x) => x.Cliente === cliente && x.NumeroPed === numped)
            .map((x) => x.PrecioTot[this.tipoMoneda])
            .reduce((a, b) => a + b, 0);
        }
      }
      return num;
    },
    numDoc(numcli, numped) {
      let data = [],
        num = 0;
      if (Object.entries(this.DetalleClienteBkO).length !== 0) {
        let { wfbackorder: wfbackorder } = this.DetalleClienteBkO;
        if (Object.entries(wfbackorder).length !== 0) {
          data = wfbackorder.filter(
            (x) => x.Cliente === numcli && x.NumeroPed === numped
          );

          num = data.length;
        }
      }
      return num;
    },
    async obtenerDatos() {
      if (Object.entries(this.Cliente).length !== 0) {
        let { resumen: resumen } = this.Cliente;
        if (Object.entries(resumen).length !== 0) {
          let { Cliente: numCli } = resumen;
          this.set_OpcCli(5);
          this.CRL_DetalleClienteBkO();
          await this.get_DetalleClienteDoc({ cliente: numCli });
        }
      }
    },
  },
  computed: {
    ...mapState([
      "DetalleClienteBkO",
      "simboloMoneda",
      "peticionDocCliente",
      "tipoMoneda",
      "Cliente",
      "GrupoCli",
    ]),
    currentTitle() {
      const titulo = {
        1: "",
        2: this.nbcli,
      };
      return titulo[this.step];
    },
    MontoTotal() {
      let num = 0;
      if (Object.entries(this.DetalleClienteBkO).length !== 0) {
        const { wfbackorder } = this.DetalleClienteBkO;
        if (wfbackorder !== undefined) {
          num = wfbackorder
            .filter((x) =>
              this.GrupoCli === 0 ? x.Cliente === this.codcli : true
            )
            .map((x) => x.PrecioTot[this.tipoMoneda])
            .reduce((a, b) => a + b, 0);
        }
      }
      return num;
    },
    detalleBackOrder: function () {
      let datos = [];
      return function (id) {
        if (Object.entries(this.DetalleClienteBkO).length !== 0) {
          let { wfbackorder: wfbackorder } = this.DetalleClienteBkO;
          if (Object.entries(wfbackorder).length !== 0) {
            datos = wfbackorder.filter((x) => id === x["NumeroPed"]);
          }
          return datos;
        }
      };
    },
    datosNew() {
      let xdatos = [];
      if (Object.entries(this.DetalleClienteBkO).length !== 0) {
        let { wfbackorder: wfbackorder } = this.DetalleClienteBkO;
        if (Object.entries(wfbackorder).length !== 0) {
          xdatos = wfbackorder;
        }
        const arrayUniqueByKey = [
          ...new Map(xdatos.map((item) => [item["NumeroPed"], item])).values(),
        ];
        return arrayUniqueByKey.sort(function (a, b) {
          if (a.Cliente > b.Cliente) {
            return 1;
          }
          if (a.Cliente < b.Cliente) {
            return -1;
          }
          // a must be equal to b
          return 0;
        });
      }
    },
  },
};
</script>
